import { useEffect } from 'react';

import useWebSocket from '~/app/hooks/useWebSocket';
import { subscribeSyncResults } from '~/data/sync/syncResultNotifier';

/**
 * Applies post-sync WebSocket updates when SyncManager finishes a drain.
 * Mount inside WebSocketProvider (not in the SQLite layer).
 */
const SyncResultEffects: React.FC = () => {
  const { syncIssues, syncUpdatedIssueDetail, syncDepartmentChange } = useWebSocket();

  useEffect(() => {
    return subscribeSyncResults((syncResult) => {
      if (syncResult.issueIds?.length) {
        syncIssues(syncResult.issueIds);
      }
      syncResult.updatedIssuesDetails?.forEach((updatedIssue) => {
        if (!updatedIssue.id) {
          return;
        }
        syncUpdatedIssueDetail(updatedIssue.id);
        if (Number(updatedIssue?.oldDepartmentId) !== Number(updatedIssue.departmentId)) {
          syncDepartmentChange({
            issueId: String(updatedIssue.id),
            oldDepartmentId: String(updatedIssue?.oldDepartmentId),
            newDepartmentId: updatedIssue.departmentId,
          });
        }
      });
    });
  }, [syncIssues, syncUpdatedIssueDetail, syncDepartmentChange]);

  return null;
};

export default SyncResultEffects;
